export const colors = ['rgb(83, 209, 140)', 'rgb(155, 155, 155)', 'rgb(196, 0, 255)', 'rgb(45, 153, 237)', 'rgb(230, 203, 0)'];